import { url } from '../utils';

const appRoutes = {
  demoKrystofee: url('/demo-krystofee/'),
  tickets: url('/tickets/'),
  ticketsDetailTicketDetail: url<{ ticketId: string }>('/tickets/detail/:ticketId/'),
  ticketsNew: url('/tickets/new/'),
  ticketsTicketIdProductsFiles: url<{ ticketId: string }>('/tickets/:ticketId/products-files'),
  products: url('/products/'),
  communication: url('/communication/'),
  customers: url('/customers/'),
  customersCustomerDetail: url<{ customerId: string }>('/customers/:customerId/'),
  settings: url('/settings/'),
  settingsUpgrade: url('/settings/upgrade/'),
  settingsUpgradeWelcome: url('/settings/upgrade/welcome/'),
  settingsAutomationTriggers: url('/settings/automation/triggers/'),
  settingsAutomationTriggersDetail: url<{ pk: string }>('/settings/automation/triggers/:pk/'),
  settingsAutomationTriggersCreate: url('/settings/automation/triggers/create/'),
  settingsAutomationTriggersInactive: url('/settings/automation/triggers/inactive/'),
  settingsBadge: url('/settings/badge/'),
  settingsBillingOverview: url('/settings/billing/overview/'),
  settingsCannedReplies: url('/settings/canned-replies/'),
  settingsCannedRepliesDetail: url<{ pk: string }>('/settings/canned-replies/:pk/'),
  settingsCannedRepliesCreate: url('/settings/canned-replies/create'),
  settingsCompany: url('/settings/company/'),
  settingsMcp: url('/settings/mcp/'),
  settingsBilling: url('/settings/billing/'),
  settingsCustomField: url('/settings/custom-field/'),
  settingsTicketCustomFieldDetail: url<{ pk: string }>('/settings/ticket-custom-field/:pk/'),
  settingsTicketCustomFieldCreate: url('/settings/ticket-custom-field/create/'),
  settingsProductCustomFieldDetail: url<{ pk: string }>('/settings/product-custom-field/:pk/'),
  settingsProductCustomFieldCreate: url('/settings/product-custom-field/create/'),
  settingsDocuments: url('/settings/documents/'),
  settingsDocumentsTicketTypeCreate: url<{ ticketType: string }>('/settings/documents/:ticketType/create/'),
  settingsDocumentsTicketTypeDetail: url<{ ticketType: string, pk: string }>('/settings/documents/:ticketType/:pk/'),
  settingsEmailing: url('/settings/emailing/'),
  settingsEmailingDetail: url<{ pk: string }>('/settings/emailing/:pk/'),
  settingsOrders: url('/settings/orders/'),
  settingsProcesses: url('/settings/processes/'),
  settingsRefunds: url('/settings/refunds/'),
  settingsRefundOptions: url('/settings/refund-options/'),
  settingsCreditNotes: url('/settings/credit-notes/'),
  settingsExchanges: url('/settings/exchanges/'),
  settingsSubscriptionsUnpaidInvoices: url('/settings/subscriptions/unpaid-invoices/'),
  settingsBillingDisabledVerifyPayment: url('/settings/billing/disabled-verify-payment/'),
  settingsTags: url('/settings/tags/'),
  settingsTagsDetail: url<{ pk: string }>('/settings/tags/:pk'),
  settingsTeam: url('/settings/team/'),
  settingsTicketTypes: url('/settings/ticket-types/'),
  settingsTicketTypesDetail: url<{ pk: string }>('/settings/ticket-types/:pk/'),
  settingsTicketTypesFormPkForm: url<{ pk: string }>('/settings/ticket-types-form/:pk/form/'),
  settingsTicketViews: url('/settings/ticket-views/'),
  settingsTicketViewsDetail: url<{ pk: string }>('/settings/ticket-views/:pk/'),
  settingsTicketViewsCreate: url('/settings/ticket-views/create/'),
  settingsTransportCustomerPaid: url('/settings/transport/customer-paid/'),
  settingsTransportShipping: url('/settings/transport/shipping/'),
  settingsUser: url('/settings/user/'),
  settingsApiV2: url('/settings/api-v2/'),
  settingsApiV2Webhooks: url('/settings/api-v2/webhooks/'),
  settingsApiV2WebhooksDetail: url<{ pk: string }>('/settings/api-v2/webhooks/:pk/'),
  settingsShippingIntegrations: url('/settings/shipping/integrations/'),
  settingsShippingContract: url('/settings/shipping/contract/'),
  settingsShippingContractDetail: url<{ pk: string }>('/settings/shipping/contract/:pk/'),
  settingsShippingAddresses: url('/settings/shipping/addresses/'),
  settingsShippingCustomerPaid: url('/settings/shipping/customer-paid/'),
  settingsShippingShopPaid: url('/settings/shipping/shop-paid/'),
  settingsShippingShippingContractsCreate: url('/settings/shipping/shipping-contracts-create/'),
  settingsShippingShippingContractsDetail: url<{ pk: string }>('/settings/shipping/shipping-contracts/:pk/'),
  settingsShippingAutomation: url('/settings/shipping/automation/'),
  settingsMarketplace: url('/settings/marketplace/'),
  settingsMarketplaceInstalledPluginDetail: url<{ pk: string, ticketType: string }>('/settings/marketplace/installed-plugin/:pk/?ticket_type=:ticketType'),
  settingsPortal: url('/settings/portal/'),
  settingsPortalIntegration: url('/settings/portal/integration/'),
  settingsShippingPortal: url('/settings/shipping/portal/'),
  settingsShippingPortalIntegration: url('/settings/shipping/portal/integration/'),
  settingsEmailDomains: url('/settings/email-domains/'),
  settingsEmailDomainsDetail: url<{ pk: string }>('/settings/email-domains/:pk/'),
  settingsEmailDomainsPkRefresh: url<{ pk: string }>('/settings/email-domains/:pk/refresh/'),
  settingsWorkflowsFlows: url('/settings/workflows/flows/'),
  notifications: url('/notifications/'),
  documentsIframeDocumentPreviewDetail: url<{ pk: string }>('/documents/iframe/document-preview/:pk/'),
  stats: url('/stats/'),
  statsRating: url('/stats/rating/'),
  statsProducts: url('/stats/products/'),
  statsReturnRate: url('/stats/return-rate/'),
  onboardingPlatformIntegrationPlatformIntegrationIdConnectAccount: url<{ platformIntegrationId: string }>('/onboarding/platform-integration/:platformIntegrationId/connect-account/'),
  orders: url('/orders/'),
  refunds: url('/refunds/'),
  shipping: url('/shipping/'),
  shippingNewShopPaidUsageExport: url('/shipping-new/shop-paid/usage-export'),
  shippingPortalShipping: url('/shipping-portal/shipping'),
  activity: url('/activity/'),
  index: url('/'),
  demo: url('/demo/'),
  search: url('/search/'),
  tracking: url('/tracking/'),
  trackingShipping: url('/tracking/shipping/'),
  trackingIssues: url('/tracking/issues/'),
  trackingAnalytics: url('/tracking/analytics/'),
  trackingSettingsProviders: url('/tracking/settings/providers/'),
  trackingSettingsOrders: url('/tracking/settings/orders/'),
  trackingSettingsOrdersCopIdStatusMapping: url<{ copId: string }>('/tracking/settings/orders/:copId/status-mapping/'),
  trackingSettingsTags: url('/tracking/settings/tags/'),
  trackingSettingsIssueTypes: url('/tracking/settings/issue-types/'),
  trackingSettingsCarrierTransitTimes: url('/tracking/settings/carrier-transit-times/'),
  trackingSettingsTrackntraceIntegrations: url('/tracking/settings/trackntrace/integrations/'),
  trackingSettingsCostAnalysis: url('/tracking/settings/cost-analysis/'),
  trackingSettingsWebhooks: url('/tracking/settings/webhooks/'),
  trackingSettingsAutomation: url('/tracking/settings/automation/'),
  trackingSettingsEmailing: url('/tracking/settings/emailing/'),
  trackingSettingsNotifications: url('/tracking/settings/notifications/'),
  flows: url('/flows/'),
  authTwoFactorRequired: url('/auth/two-factor-required/'),
  settingsBranches: url('/settings/branches/'),
}

export default appRoutes;
